export const GET_LIST_TEMPLATES_LOADING = 'templates/GET_LIST_TEMPLATES_LOADING';
export const GET_LIST_TEMPLATES_SUCCESS = 'templates/GET_LIST_TEMPLATES_SUCCESS';
export const GET_LIST_TEMPLATES_FAILURE = 'templates/GET_LIST_TEMPLATES_FAILURE';

export const GET_PARAMETERS_TEMPLATE_LOADING = 'templates/GET_PARAMETERS_TEMPLATE_LOADING';
export const GET_PARAMETERS_TEMPLATE_SUCCESS = 'templates/GET_PARAMETERS_TEMPLATE_SUCCESS';
export const GET_PARAMETERS_TEMPLATE_FAILURE = 'templates/GET_PARAMETERS_TEMPLATE_FAILURE';

export const SAVE_PARAMETERS_TEMPLATE_LOADING = 'templates/SAVE_PARAMETERS_TEMPLATE_LOADING';
export const SAVE_PARAMETERS_TEMPLATE_SUCCESS = 'templates/SAVE_PARAMETERS_TEMPLATE_SUCCESS';
export const SAVE_PARAMETERS_TEMPLATE_FAILURE = 'templates/SAVE_PARAMETERS_TEMPLATE_FAILURE';
